<template>
  <div v-if="dataValue">
    <v-tabs v-model="model" centered slider-color="yellow">
      <v-tab :href="`#tab-1`">
        {{ $t('setting') }}
      </v-tab>
      <v-tab :href="`#tab-2`">
        {{ $t('activate_date_time') }}
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="model">
      <v-tab-item
        :value="`tab-1`"
        style="height: 700px; background: var(--v-surface-base)"
      >
        <v-container style="background: var(--v-surface-base)">
          <v-card flat>
            <h4 class="mt-3 mb-2">
              {{ $t('set_the_time_to_turn_on_rich_menu') }}
              <span class="color-red">*</span>
            </h4>

            <v-btn
              rounded
              color="primary"
              dark
              :outlined="type === 'advanced'"
              small
              @click="
                type = 'normal'
                dataValue.weekDate = []
              "
            >
              {{ $t('common') }}
            </v-btn>
            <v-btn
              class="ml-2"
              rounded
              color="primary"
              :outlined="type === 'normal'"
              small
              @click="type = 'advanced'"
            >
              {{ $t('advance') }}
            </v-btn>
            <div v-if="type == 'normal'" class="mt-2 color-primary">
              <small>{{ $t('start_date') }}</small>
            </div>
            <v-row>
              <v-col cols="12" sm="6">
                <div v-if="type == 'advanced'" class="mt-2 color-primary">
                  <small>{{ $t('start_date') }}</small>
                </div>
                <v-menu
                  v-model="menu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template #activator="{ on, attrs }">
                    <v-text-field
                      v-model="dataValue.date"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      dense
                      outlined
                      hide-details
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="dataValue.date"
                    :allowed-dates="allowedDates"
                    @input="menu = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col>
                <div v-if="type == 'advanced'" class="mt-2 color-primary">
                  <small>{{ $t('end_date') }}</small>
                </div>
                <v-menu
                  v-if="type === 'normal'"
                  ref="menuTime"
                  v-model="menuTime"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  :return-value.sync="dataValue.time"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template #activator="{ on, attrs }">
                    <v-text-field
                      v-model="dataValue.time"
                      label="Picker in menu"
                      prepend-icon="mdi-clock-time-four-outline"
                      readonly
                      v-bind="attrs"
                      dense
                      outlined
                      hide-details
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-time-picker
                    v-if="menuTime"
                    v-model="dataValue.time"
                    :allowed-minutes="allowedStep"
                    full-width
                    format="24hr"
                    @click:minute="$refs.menuTime.save(dataValue.time)"
                  ></v-time-picker>
                </v-menu>
                <v-menu
                  v-else
                  v-model="menu2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template #activator="{ on, attrs }">
                    <v-text-field
                      v-model="dataValue.date2"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      dense
                      outlined
                      hide-details
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="dataValue.date2"
                    :allowed-dates="allowedDates"
                    @input="menu2 = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
            <div v-if="type === 'normal'" class="mt-2 color-primary">
              <small>{{ $t('end_date') }}</small>
            </div>
            <v-row v-if="type === 'normal'">
              <v-col cols="12" sm="6">
                <v-menu
                  v-model="menu2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template #activator="{ on, attrs }">
                    <v-text-field
                      v-model="dataValue.date2"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      dense
                      outlined
                      hide-details
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="dataValue.date2"
                    :allowed-dates="allowedDates"
                    @input="menu2 = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col>
                <v-menu
                  v-if="type === 'normal'"
                  ref="menuTime2"
                  v-model="menuTime2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  :return-value.sync="dataValue.time2"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template #activator="{ on, attrs }">
                    <v-text-field
                      v-model="dataValue.time2"
                      label="Picker in menu"
                      prepend-icon="mdi-clock-time-four-outline"
                      readonly
                      v-bind="attrs"
                      dense
                      outlined
                      hide-details
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-time-picker
                    v-if="menuTime2"
                    v-model="dataValue.time2"
                    full-width
                    :allowed-minutes="allowedStep"
                    format="24hr"
                    @click:minute="$refs.menuTime2.save(dataValue.time2)"
                  ></v-time-picker>
                </v-menu>
              </v-col>
            </v-row>
            <template v-if="type == 'advanced'">
              <h4 class="mb-2 mt-5">{{ $t('select_working_day') }}</h4>
              <v-select
                v-model="dataValue.weekDate"
                dense
                :items="dateOption"
                attach
                chips
                multiple
                outlined
              ></v-select>
            </template>
          </v-card>
        </v-container>
      </v-tab-item>
      <v-tab-item :value="`tab-2`">
        <v-card flat>
          <v-card-text>
            <v-data-table
              :headers="headers"
              :items="history"
              class="elevation-1"
              hide-default-footer
            >
              <template #item="props">
                <tr>
                  <td>
                    {{ formatDate(props.item.start_at, 'DD/MM/YYYY - HH.mm') }}
                  </td>
                  <td>
                    {{ formatDate(props.item.end_at, 'DD/MM/YYYY - HH.mm') }}
                  </td>
                  <td>
                    <span
                      v-if="setting && setting.date && setting.date.length > 0"
                      >{{ $t(checkDayByDate(props.item.start_at)) }}</span
                    >
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import dayjs from 'dayjs'
export default {
  props: ['value'],
  data: () => ({
    model: 'tab-1',
    menu2: false,
    menu: false,
    weekday: [
      'Sunday',
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday',
      'Saturday'
    ],
    menuTime: false,
    menuTime2: false,
    dataValue: null,
    history: [],
    type: 'normal',
    setting: null
  }),
  mounted() {
    const vm = this
    vm.dataValue = vm.value
    if (vm.lineRichmenu && vm.lineRichmenu.length !== 0 && vm.templateSelect) {
      vm.lineRichmenu.forEach((item) => {
        if (item.id === vm.templateSelect.id) {
          vm.history = item.set_default_schedule
          let dataTimeStart = []
          let dataTimeEnd = []
          vm.setting = null
          try {
            vm.setting = JSON.parse(item.set_default_schedule_setting)
          } catch (error) {
            console.error(error)
          }
          if (
            vm.setting &&
            vm.setting.start_time_at &&
            vm.setting.end_time_at
          ) {
            dataTimeStart = vm.setting.start_time_at.split(':')
            dataTimeEnd = vm.setting.end_time_at.split(':')
            vm.setting.start_time_at = `${dataTimeStart[0]}:${dataTimeStart[1]}`
            vm.setting.end_time_at = `${dataTimeEnd[0]}:${dataTimeEnd[1]}`
          }

          if (vm.setting && vm.setting !== 'undefined') {
            vm.dataValue = {
              date: dayjs(vm.setting.start_date_at).format('YYYY-MM-DD'),
              date2: dayjs(vm.setting.end_date_at).format('YYYY-MM-DD'),
              time: vm.setting.start_time_at,
              time2: vm.setting.end_time_at,
              weekDate: vm.setting.date
            }
            if (vm.setting.date.length > 0) {
              vm.type = 'advanced'
              vm.model = 'tab-2'
            }
          }
        }
      })

      vm.$emit('input', vm.dataValue)

      vm.history.sort(function (a, b) {
        return new Date(a.start_at) - new Date(b.start_at)
      })
    }
  },
  computed: {
    ...mapGetters({
      templateSelect: 'lineRichmenuManager/getTemplateSelect',
      lineRichmenu: 'lineRichmenuManager/getLineRichMenu'
    }),
    dateRangeText() {
      return this.dates.join(' ~ ')
    },
    headers() {
      return [
        {
          text: this.$t('starts_date_time'),
          align: 'center',
          sortable: false,
          value: 'start'
        },
        {
          text: this.$t('ends_date_time'),
          align: 'center',
          sortable: false,
          value: 'end'
        },
        {
          text: this.$t('working_day'),
          align: 'center',
          sortable: false,
          value: 'day'
        }
      ]
    },
    dateOption() {
      const vm = this
      let days = []
      let setDays = []
      if (vm.dataValue) {
        vm.getDatesInRange(vm.dataValue.date, vm.dataValue.date2).map(
          (item) => {
            if (!days.includes(vm.weekday[item.getDay()])) {
              days.push(vm.weekday[item.getDay()])
            }
          }
        )
        vm.weekday.map((item) => {
          days.forEach((day) => {
            if (day === item) {
              setDays.push(day)
            }
          })
        })
      }
      return setDays
    }
  },
  methods: {
    checkDayByDate(date) {
      const vm = this
      return vm.weekday[new Date(date).getDay()]
    },
    formatDate(date, format) {
      return dayjs(date).format(format)
    },
    allowedDates(val) {
      return dayjs().diff(val, 'days') < 1
    },
    getDatesInRange(startDate, endDate) {
      for (
        var arr = [], dt = new Date(startDate);
        dt <= new Date(endDate);
        dt.setDate(dt.getDate() + 1)
      ) {
        arr.push(new Date(dt))
      }
      return arr
    },
    allowedStep: (m) => m % 10 === 0
  }
}
</script>

<style lang="scss" scoped></style>
